<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="text-align: center;margin-top:150px;">“She thinks of nothing but the Isle of Wight, and she calls it ‘The Island’ as if there was no other island in the world.”</p>
<p style="text-align: center;">Jane Austen – <em>Mansfield Park</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?40b1b55a